<li class="app-list-item" [ngClass]="{'selected':selected}">
  <div mat-ripple class="app-list-item-content" (click)="handleClick()">
    <ng-content></ng-content>
  </div>
  @if (expanded) {
    <div class="app-list-item-details-container" >
      <ng-content select="app-list-item-detail"></ng-content>
    </div>
  }
</li>
